import { ModuleWithProviders, NgModule } from '@angular/core';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { RtUICommonModule } from '../common/common.module';
import { RtUIFormsModule } from '../forms/forms.module';
import { RtUIIntersectionObserverModule } from '../intersection-observer/intersection-observer.module';
import { AttributesSelectListComponent } from './attributes-select-list/attributes-select-list.component';
import { AttributesSelectComponent } from './attributes-select/attributes-select.component';
import { AttributesComponent } from './attributes.component';
import { RtUIAttributesTranslations, RtUIAttributesTranslationsContexts } from './attributes.types';
import { InputAttributesComponent } from './input-attributes/input-attributes.component';

@NgModule({
  imports: [
    RtUICommonModule,
    RtUIFormsModule,
    RtUIIntersectionObserverModule,
    VirtualScrollerModule,
  ],
  declarations: [
    InputAttributesComponent,
    AttributesComponent,
    AttributesSelectComponent,
    AttributesSelectListComponent,
  ],
  exports: [AttributesComponent, InputAttributesComponent, AttributesSelectComponent],
})
export class RtUIAttributesModule {
  public static withTranslations(
    translations: RtUIAttributesTranslationsContexts,
  ): ModuleWithProviders<RtUIAttributesModule> {
    return {
      ngModule: RtUIAttributesModule,
      providers: [{ provide: RtUIAttributesTranslations, useValue: translations }],
    };
  }
}

export { AttributesSelectComponent } from './attributes-select/attributes-select.component';
export { AttributesSelectListComponent } from './attributes-select-list/attributes-select-list.component';
export { AttributesComponent } from './attributes.component';
export { InputAttributesComponent } from './input-attributes/input-attributes.component';
export * from './attributes.types';
